<template>
  <div id="home">
	  <div class="header">
		 <div class="menu-box">
			<div class="logo-box">
				<img class="logo" src="https://cdn.molouadx.com/web/logo.png"/>
			</div>
			 <div class="menu-items">
				 <div :class='curPage=="home"? "menu-item menu-item-active" : "menu-item"'  @click="scrollToTop">首 页</div>
				 <div :class='curPage=="product"? "menu-item menu-item-active" : "menu-item"' @click="scrollToView('product-section', 'product')">产品优势</div>
				 <!-- <div class="menu-item">合作案例</div> -->
				 <div :class='curPage=="case"? "menu-item menu-item-active" : "menu-item"' @click="scrollToView('case-section', 'case')">联系我们</div>
			 </div>
			 <div class="btn-box">
				 <div class="btn-panel">
					 <div class="btn-login" @click="goToAdmin">登录</div>
					 <div class="btn" @click="goToAdmin">立即注册</div>
				 </div>
			 </div>
		 </div>
	  </div>
	  <div class="header-section">
		  <div class="header-content">
			  <div class="title-main">聚流成金，驷象助赢</div>
			  <div class="title-sub">一站式流量变现专家</div>
			  <div class="header-description">
				  创新智能广告平台，融合算法与动态技术，精准匹配优质流量，<br/>高效分配每一分预算，最大化开发者变现收益，让广告价值倍增！
			  </div>
			  <div class="btn" @click="goToAdmin">开始使用</div>
		  </div>
	  </div>
	  <div class="product-section" id="product-section">
		  <div class="product-content">
			  <div class="product-main">
				  <div class="main-left">
					  <img class="icon" src="https://cdn.molouadx.com/web/product-icon.png"/>
				  </div>
				  <div class="main-right">
					  <div class="title">"驷象网络 —— 让全球流量如象群奔涌而至"</div>
					  <div class="description">在数字化浪潮奔涌的时代，流量如同奔腾的象群，蕴藏商业世界的无限动能。
作为专注全球化流量变现的智能广告平台，驷象网络以四大核心势能——智能聚合、精准丈量、全域触达、价值深挖，助力客户在流量原野上开拓专属商业疆域。</div>
				  </div>
			  </div>
			  <div class="product-data">
				  <div class="data-item">
					  <div class="data-num">10000+</div>
					  <div class="data-name">合作APP</div>
				  </div>
				  <div class="data-item">
					  <div class="data-num">5000万+</div>
					  <div class="data-name">日活</div>
				  </div>
				  <div class="data-item">
					  <div class="data-num">10亿+</div>
					  <div class="data-name">日请求数</div>
				  </div>
				  <div class="data-item">
					  <div class="data-num">100万+</div>
					  <div class="data-name">单联盟日收益</div>
				  </div>
			  </div>
		  </div>
	  </div>
	  <div class="feature-section">
		  <div class="feature-content">
			  <div class="title-box">
				  <div class="title-wrap">10亿+流量优势</div>
			  </div>
			  <div class="feature-description">
				  创新互动广告形态，覆盖超 2 亿在线移动 APP 用户，通过技术驱动的生态协同机制，平衡媒体收益、用户体验与广告转化效能，构建媒体主、广告主与用户的三维价值共生生态，实现商业价值与用户体验的双向跃升。
			  </div>
			  <div class="feature-main">
				  <div class="main-item">
					  <div class="main-content">
						  <div class="main-title">
							  结算周期灵活
						  </div>
						  <div class="main-description">日结/周结/月结，根据客户需求可以选择合适的结算周期，对账单确认后，无特殊情况，当日即可打款。</div>
					  </div>
				  </div>
				  <div class="main-item main-item-2">
					  <div class="main-content">
					  <div class="main-title">
					  		海量广告资源
					  </div>
					  <div class="main-description">SDK聚合四大联盟、以及国内外各种优秀的直客渠道。填充率高、预算充足</div>
					  </div>
				  </div>
				  <div class="main-item main-item-3">
					  <div class="main-content">
					  <div class="main-title">
					  		专家级运营团队
					  </div>
					  <div class="main-description">媒体运营专家、广告优化师 1V1协助分析优化 快速响应，结合路径内容场景深度定制</div>
					  </div>
				  </div>
			  </div>
		  </div>
	  </div>
	  <div class="edge-section">
		  <div class="edge-content">
			  <div class="title-box">
				  <div class="title-wrap">四大独特竞争力</div>
			  </div>
			  <div class="edge-main">
				  <div class="main-item">
					  <div class="item-title-box">
					  		<div class="box-label"></div>
							<div class="box-right">
								<div>技术为基: </div>
								<div>全平台智能广告技术支撑</div>
							</div>
					  </div>
					  <div class="item-panel">
						  1.驷象网络提供APP/H5/小程序全平台支持，秒级响应引擎确保流畅体验，深度反作弊系统保障流量质量。<br/>
						  2.开放媒体API接口，实现从流量对接、智能匹配到结算提现的全流程自动化，让变现更高效可靠。
					  </div>
					  
					  <div class="item-title-box" style="margin-top: 80px;">
							<div class="box-label label-color3"></div>
							<div class="box-right">
								<div>服务为盾: </div>
								<div>7×24小时专业护航</div>
							</div>
					  </div>
					  <div class="item-panel">
					  		5年经验团队建立快速响应机制，严格审核加先行赔付政策双保障，已服务2000+开发者，客户满意度98%。
					  </div>
				  </div>
				  <div class="main-item item-center">
					  <img class="icon" src="https://cdn.molouadx.com/web/edge-logo.png"/>
				  </div>
				  <div class="main-item">
					  <div class="item-title-box">
						  <div class="box-label label-color2"></div>
						  <div class="box-right">
						  	<div>技术为基: </div>
						  	<div>智能算法提升变现效率</div>
						  </div>
					  </div>
					  <div class="item-panel">
						  1.通过动态出价算法与精准流量匹配，帮助开发者平均提升40%+收益。<br/>
						  2.实时优化广告策略，案例显示ARPDAU最高提升60%。
					  </div>
					  <div class="item-title-box" style="margin-top: 80px;">
							<div class="box-label label-color4"></div>
							<div class="box-right">
								<div>内容为刃: </div>
								<div>破解内容留存难题</div>
							</div>
					  </div>
					  <div class="item-panel">
					  		提供AI生成+人工优化的定制内容方案，提升15-30%用户时长，创新"内容即广告"模式，同步降本增效。
					  </div>
				  </div>
			  </div>
		  </div>
	  </div>
	  <div class="scene-section">
		  <div class="scene-content">
			  <div class="title-box">
				  <div class="title-wrap">多样化场景变现</div>
			  </div>
			  <div class="scene-description">
				  以灵活架构适配各类流量场景，既支持轻量级接口对接实现产品快速落地，又可通过深度战略合作构建长效运营体系，助力业务高效切入市场并持续释放增长潜力。
			  </div>
			  <div class="scene-main">
				  <div class="main-left">
					  <div :class="curScene == 1 ? 'left-btn left-btn-active' : 'left-btn'" @mouseenter="sceneActive(1)">开屏广告</div>
					  <div :class="curScene == 2 ? 'left-btn left-btn-active' : 'left-btn'" @mouseenter="sceneActive(2)">插屏广告</div>
					  <div :class="curScene == 3 ? 'left-btn left-btn-active' : 'left-btn'" @mouseenter="sceneActive(3)">激励视频广告</div>
					  <div :class="curScene == 4 ? 'left-btn left-btn-active' : 'left-btn'" @mouseenter="sceneActive(4)">信息流广告</div>
					  <div :class="curScene == 5 ? 'left-btn left-btn-active' : 'left-btn'" @mouseenter="sceneActive(5)">Banner广告</div>
				  </div>
				  <div class="main-right">
					  <div class="right-content" v-if="curScene == 1">
						  <div class="content-left">
							  <div class="content-left-title">
								  开屏广告
							  </div>
							  <div class="content-left-description" style="margin-top: 27px;">
								  开屏广告是一种在 APP、网站等平台启动时全屏展示的广告形式，凭借强曝光、高视觉冲击力的特点，能快速吸引用户注意力，有效传递品牌信息或推广产品服务。
							  </div>
							  <div class="sub-title" style="margin-top: 40px;">推荐场景</div>
							  <div class="content-left-description" style="padding-left: 20px;">
								  应用启动页
							  </div>
							  <div class="sub-title" style="margin-top: 20px;">支持样式</div>
							  <div class="content-left-description" style="padding-left: 20px;">
							  	  图片、视频
							  </div>
						  </div>
						  <div class="content-right">
							  <img class="right-icon" src="https://cdn.molouadx.com/web/ads-icon-1.png"/>
						  </div>
					  </div>
					  <div class="right-content" v-if="curScene == 2">
					  						  <div class="content-left">
					  							  <div class="content-left-title">
					  								  插屏广告
					  							  </div>
					  							  <div class="content-left-description" style="margin-top: 27px;">
					  								  在应用暂停、退出等节点，以半屏或全屏 形式弹出展示。 图片、视频素材类型，交互场景丰富， 深受广告主青睐，预算能力充足。
					  							  </div>
					  							  <div class="sub-title" style="margin-top: 40px;">推荐场景</div>
					  							  <div class="content-left-description" style="padding-left: 20px;">
					  								  视频贴片、弹窗场景
					  							  </div>
					  							  <div class="sub-title" style="margin-top: 20px;">支持样式</div>
					  							  <div class="content-left-description" style="padding-left: 20px;">
					  							  	  图片、视频
					  							  </div>
					  						  </div>
					  						  <div class="content-right">
					  							  <img class="right-icon" src="https://cdn.molouadx.com/web/ads-icon-2.png"/>
					  						  </div>
					  </div>
					  <div class="right-content" v-if="curScene == 3">
					  						  <div class="content-left">
					  							  <div class="content-left-title">
					  								  激励视频广告
					  							  </div>
					  							  <div class="content-left-description" style="margin-top: 27px;">
					  								  观看视频广告以免费获得奖励，沉浸式广告体验，广告点击率转化率极高。
					  							  </div>
					  							  <div class="sub-title" style="margin-top: 40px;">推荐场景</div>
					  							  <div class="content-left-description" style="padding-left: 20px;">
					  								  获取应用内奖励及权益体系的所有应用及场景
					  							  </div>
					  							  <div class="sub-title" style="margin-top: 20px;">支持样式</div>
					  							  <div class="content-left-description" style="padding-left: 20px;">
					  							  	  15~30秒竖版视频、横版视频
					  							  </div>
					  						  </div>
					  						  <div class="content-right">
					  							  <img class="right-icon" src="https://cdn.molouadx.com/web/ads-icon-3.png"/>
					  						  </div>
					  </div>
					  <div class="right-content" v-if="curScene == 4">
					  						  <div class="content-left">
					  							  <div class="content-left-title">
					  								  信息流广告
					  							  </div>
					  							  <div class="content-left-description" style="margin-top: 27px;">
					  								  与APP应用内容高度融合，常见素材类型 包括横版视频、 单图、组图。常见广告场景：资讯页、 视频详情页、 信息列表页等。
					  							  </div>
					  							  <div class="sub-title" style="margin-top: 40px;">推荐场景</div>
					  							  <div class="content-left-description" style="padding-left: 20px;">
					  								  资讯页、视频详情页、信息列表页
					  							  </div>
					  							  <div class="sub-title" style="margin-top: 20px;">支持样式</div>
					  							  <div class="content-left-description" style="padding-left: 20px;">
					  							  	  横版视频、单图、组图
					  							  </div>
					  						  </div>
					  						  <div class="content-right">
					  							  <img class="right-icon" src="https://cdn.molouadx.com/web/ads-icon-4.png"/>
					  						  </div>
					  </div>
					  <div class="right-content" v-if="curScene == 5">
					  						  <div class="content-left">
					  							  <div class="content-left-title">
					  								  Banner广告
					  							  </div>
					  							  <div class="content-left-description" style="margin-top: 27px;">
					  								  在APP顶/中/底部悬浮且可关闭的边栏广告，位置固定，展示时间较长，高曝光低干扰，实现稳定广告收入。
					  							  </div>
					  							  <div class="sub-title" style="margin-top: 40px;">推荐场景</div>
					  							  <div class="content-left-description" style="padding-left: 20px;">
					  								  视频播放页、工具功能页等顶部、中部、底部
					  							  </div>
					  							  <div class="sub-title" style="margin-top: 20px;">支持样式</div>
					  							  <div class="content-left-description" style="padding-left: 20px;">
					  							  	  图片、文字、轮播图、GIF图
					  							  </div>
					  						  </div>
					  						  <div class="content-right">
					  							  <img class="right-icon" src="https://cdn.molouadx.com/web/ads-icon-5.png"/>
					  						  </div>
					  </div>
				  </div>
			  </div>
		  </div>
	  </div>
	  <div class="case-section" id="case-section">
		  <div class="case-content">
			  <div class="title-box">
				  <div class="title-wrap">
				  		一站式接入 快速方便
				  </div>
			  </div>
			  <div class="description">快速入驻，对接更便利合作流程更简单。我们提供专业的技术支持和完善的服务体系， 让您的业务快速落地，轻松实现商业价值。</div>
			  <div class="case-main">
				  <div class="main-item">
					  <div class="item-no">01</div>
					  <div class="item-title">洽谈合作</div>
					  <div class="item-description">专业运营团队深入了解您的业务需求，提供个性化解决方案建议</div>
				  </div>
				  <div class="main-item">
					  <div class="item-no">02</div>
					  <div class="item-title">制定方案</div>
					  <div class="item-description">根据您的具体需求，量身定制专属商务合作方案，确保最大化商业价值</div>
				  </div>
				  <div class="main-item">
					  <div class="item-no">03</div>
					  <div class="item-title">对接工作</div>
					  <div class="item-description">全面收集并整理相关资料信息，建立完整的业务档案，确保合作顺利进行</div>
				  </div>
				  <div class="main-item">
					  <div class="item-no">04</div>
					  <div class="item-title">开始对接</div>
					  <div class="item-description">专业技术团队全程跟进，提供 7×24 小时技术支持服务，保障对接过程顺畅</div>
				  </div>
			  </div>
			  <div class="case-main">
				  <div class="main-item">
					  <div class="item-no">05</div>
					  <div class="item-title">测试验收</div>
					  <div class="item-description">严格的测试流程和完善的验收标准，确保系统稳定运行和数据准确性</div>
				  </div>
				  <div class="main-item">
					  <div class="item-no">06</div>
					  <div class="item-title">SDK上线</div>
					  <div class="item-description">快速部署上线，智能化运营系统助力业务增长，实现收益最大化</div>
				  </div>
				  <div class="main-item">
					  <div class="item-no">07</div>
					  <div class="item-title">运营调优</div>
					  <div class="item-description">实时监控数据表现，深度分析优化策略，持续提升运营效果</div>
				  </div>
				  <div class="main-item">
					  <div class="item-no">08</div>
					  <div class="item-title">结算支付</div>
					  <div class="item-description">规范的结算流程，准确及时的收益结算，资金安全有保障</div>
				  </div>
			  </div>
		  </div>
	  </div>
	  <div class="footer">
		  <div class="footer-content">
			  <div class="title">现在注册  立即体验驷象服务</div>
			  <div class="btn" @click="goToAdmin">立即注册</div>
		  </div>
		  <img class="icon" src="https://cdn.molouadx.com/web/qrcode.jpeg"/>
	  </div>
  </div>
</template>

<script>
export default {
	name:'home',
	data() {
		return {
			curPage: 'home',
			curScene: '1'
		}
	},
	created() {
	  document.title = '驷象网络聚合广告平台';
	},
  methods: {
	  sceneActive(flag) {
		  this.curScene = flag;
	  },
	  navTo(url, page) {
	  	this.curPage = page;
	  	this.$router.push({ path:url})
	  },
	  gotoTop() {
		location.reload();
	  },
	  goUrl(url){
		   window.open(url);
	  },
	  goToAdmin(){
	  	  this.goUrl('https://www.molouadx.com/admin')
	  },
	  scrollToTop() {
		  this.curPage="home";
	      const rootElement = document.documentElement || document.body;
	      rootElement.scrollTo({
	          top: 0,
	          behavior: "smooth"
	      });
	  },
	  scrollToView(id, page) {
		  this.curPage = page;
		  let element = document.getElementById(id);
		  element.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
	  },
  }
}
</script>

<style lang="less">
#home {
width: 100%;
  .header {
	  width: 100%;
	  height: 80px;
	  background-color: #10162E;
	  display: flex;
	  align-items: center;
	  z-index: 999999;
	  position: fixed;
	  left: 0;
	  top:0 ;
	  .menu-box {
		  width: 100%;
		  height:60px;
		  display: flex;
		  .logo-box {
			  flex:2;
			  display: flex;
			  justify-content: center;
			  .logo {
				  width: 172px;
				  height: 60px;
			  }
		  }
		  .menu-items {
			  flex:2;
			  display: flex;
			  justify-content: center;
			  .menu-item {
				  height: 40px;
				  cursor: pointer;
				  font-family: Roboto, Roboto;
				  font-weight: 400;
				  font-size: 16px;
				  color: #FFFFFF;
				  line-height: 58px;
				  text-align: left;
				  font-style: normal;
				  text-transform: none;
				  margin-right: 32px;
			  }
			  .menu-item-active {
				  color: #FF5722;
				  border-bottom: 6px solid #FF5722;
			 }
		  }
		  .btn-box {
			  flex:1;
			  display: flex;
			  justify-content: center;
			  .btn-panel {
				  display: flex;
				  align-items: center;
				  .btn-login {
					  cursor: pointer;
					  font-family: Roboto, Roboto;
					  font-weight: 400;
					  font-size: 16px;
					  color: #FFFFFF;
					  line-height: 60px;
					  text-align: center;
					  font-style: normal;
					  text-transform: none;
					  margin-right: 30px;
				  }
				  .btn {
					  cursor: pointer;
					  width: 112px;
					  height: 40px;
					  background: #FF5722;
					  border-radius: 4px 4px 4px 4px;
					  font-family: Roboto, Roboto;
					  font-weight: 400;
					  font-size: 16px;
					  color: #FFFFFF;
					  line-height: 40px;
					  text-align: center;
					  font-style: normal;
					  text-transform: none;
				  }
			  }
		  }
	  }
  }
  .header-section {
	  // margin-top: 20px;
	  aspect-ratio: 1920 / 800;
	  background: url(https://cdn.molouadx.com/web/header-bg.jpg) no-repeat;
	  background-size: cover;
	  width:100%;
	  padding-top: 200px;
	  .header-content {
		  padding-left: 180px;
		  .title-main {
		  		  font-family: Roboto, Roboto;
		  		  font-weight: 700;
		  		  font-size: 40px;
		  		  line-height: 60px;
		  		  text-align: left;
		  		  font-style: normal;
		  		  text-transform: none;
				  /* 新增以下属性实现渐变 */
				      background: linear-gradient(180deg, #FF5722 0%, #FF9800 100%);
				      -webkit-background-clip: text; /* Safari浏览器兼容 */
				      background-clip: text;
				      color: transparent;
		  		  
		  }
		  .title-sub {
			  font-family: Roboto, Roboto;
			  font-weight: 700;
			  font-size: 40px;
			  color: #FFFFFF;
			  line-height: 60px;
			  text-align: left;
			  font-style: normal;
			  text-transform: none;
			  margin-left: 68px;
		  }
		  .header-description {
			  font-family: Roboto, Roboto;
			  font-weight: 400;
			  font-size: 20px;
			  color: #CACACA;
			  line-height: 28px;
			  text-align: left;
			  font-style: normal;
			  text-transform: none;
			  margin-top: 82px;
		  }
		  .btn {
			  margin-top: 88px;
			  cursor: pointer;
			  width: 136px;
			  height: 52px;
			  background: #FF5722;
			  border-radius: 4px 4px 4px 4px;
			  font-family: Roboto, Roboto;
			  font-weight: 400;
			  font-size: 18px;
			  color: #FFFFFF;
			  line-height: 52px;
			  text-align: center;
			  font-style: normal;
			  text-transform: none;
		  }
	  }
  }
  .product-section {
	  width: 100%;
	  height: 680px;
	  background-color: #10162E;
	  .product-content {
		width: 66%;
		margin-left: 17%;
		padding-top: 150px;
		.product-main {
			display: flex;
			.main-left {
				flex: 1;
				display: flex;
				justify-content: center;
				.icon {
					width: 400px;
					height: 229px;
				}
			}
			.main-right {
				flex: 1;
				.title {
					font-family: Roboto, Roboto;
					font-weight: 700;
					font-size: 22px;
					color: #FFFFFF;
					line-height: 52px;
					text-align: left;
					font-style: normal;
					text-transform: none;
					// margin-top: 37px;
				}
				.description {
					font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
					font-weight: 400;
					font-size: 16px;
					color: #FFFFFF;
					line-height: 35px;
					text-align: left;
					font-style: normal;
					text-transform: none;
					margin-top: 25px;
				}
			}
		}
		.product-data {
			margin-top: 130px;
			display: flex;
			justify-content: space-between;
			.data-item {
				width: 164px;
				height: 88px;
				.data-num {
					font-family: Roboto, Roboto;
					font-weight: 700;
					font-size: 38px;
					line-height: 52px;
					text-align: center;
					font-style: normal;
					text-transform: none;
					background: linear-gradient(90deg, #FF5A21 3%, #FF9601 100%);
					-webkit-background-clip: text; /* Safari浏览器兼容 */
					background-clip: text;
					color: transparent;
				}
				.data-name {
					font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
					font-weight: 400;
					font-size: 16px;
					color: #999999;
					line-height: 25px;
					text-align: center;
					font-style: normal;
					text-transform: none;
				}
			}
		}
	  }
  }
  .feature-section {
	  width: 100%;
	  height: 900px;
	  background-color: #10162E;
	  .feature-content {
	  		width: 66%;
	  		margin-left: 17%;
	  		padding-top: 50px;
			.title-box {
				width: 70%;
				margin-left: 15%;
				aspect-ratio: 1012 / 112;
				background: url(https://cdn.molouadx.com/web/title-bg.png) no-repeat;
				background-size: cover;
				display: flex;
				justify-content: center;
				align-items: center;
				.title-wrap {
					height: 50px;
					font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
					font-weight: 400;
					font-size: 32px;
					color: #FFFFFF;
					line-height: 45px;
					text-align: center;
					font-style: normal;
					text-transform: none;
				}
			}
			.feature-description {
				margin-top: 50px;
				font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
				font-weight: 400;
				font-size: 16px;
				color: #FFFFFF;
				line-height: 32px;
				text-align: center;
				font-style: normal;
				text-transform: none;
			}
			.feature-main {
				margin-top: 90px;
				display: flex;
				justify-content: space-between;
				.main-item {
					width: 280px;
					height: 399px;
					background: url('https://cdn.molouadx.com/web/feature-icon1.png') no-repeat;
					background-size: 280px 399px;
					.main-content {
						padding: 70px 30px;
						.main-title {
							font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
							font-weight: 400;
							font-size: 20px;
							color: #030C22;
							line-height: 41px;
							text-align: center;
							font-style: normal;
							text-transform: none;
						}
						.main-description {
							font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
							font-weight: 400;
							font-size: 14px;
							color: #030C22;
							line-height: 22px;
							text-align: left;
							font-style: normal;
							text-transform: none;
						}
					}
				}
				.main-item-2 {
					background: url('https://cdn.molouadx.com/web/feature-icon2.png') no-repeat;
					background-size: 280px 399px;
				}
				.main-item-3 {
					background: url('https://cdn.molouadx.com/web/feature-icon3.png') no-repeat;
					background-size: 280px 399px;
				}
			}
	  }
  }
  .edge-section {
	  width: 100%;
	  height: 800px;
	  background-color: #10162E;
	  .edge-content {
		  width: 66%;
		  margin-left: 17%;
		  padding-top: 50px;
		  .title-box {
		  	width: 70%;
		  	margin-left: 15%;
		  	aspect-ratio: 1012 / 112;
		  	background: url(https://cdn.molouadx.com/web/title-bg.png) no-repeat;
		  	background-size: cover;
		  	display: flex;
		  	justify-content: center;
		  	align-items: center;
		  	.title-wrap {
		  		height: 50px;
		  		font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
		  		font-weight: 400;
		  		font-size: 32px;
		  		color: #FFFFFF;
		  		line-height: 45px;
		  		text-align: center;
		  		font-style: normal;
		  		text-transform: none;
		  	}
		  }
		  .edge-main {
				  margin-top: 100px;
		  		  display: flex;
		  		  justify-content: space-between;
		  		  .main-item {
		  			  flex: 1;
		  			  width: 280px;
		  			  height: 500px;
					  .item-title-box {
						  display: flex;
						  .box-label {
							  width: 8px;
							  height: 60px;
							  margin-right: 5px;
							  background: #2F8F48;
						  }
						  .label-color2 {
						  	 background: #026AB1;
						  }
						  .label-color3 {
						  	background: #EF9E20;
						  }
						  .label-color4 {
						  	background: #FF5722;
						  }
						  .box-right {
							  font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
							  font-weight: 500;
							  font-size: 20px;
							  color: #FFFFFF;
							  line-height: 32px;
							  text-align: left;
							  font-style: normal;
							  text-transform: none;
						  }
					  }
					  .item-panel {
						  height: 150px;
						  padding: 20px;
						  font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
						  font-weight: 400;
						  font-size: 14px;
						  color: #FFFFFF;
						  line-height: 25px;
						  text-align: justify;
						  font-style: normal;
						  text-transform: none;
					  }
		  		  }
				  .item-center {
					  display: flex;
					  align-items: center;
					  justify-content: center;
					  .icon {
						  width: 248px;
						  height: 308px;
					  }
				  }
		  }
	  }
  }
  .scene-section {
	  aspect-ratio: 1924 / 1080;
	  background: url(https://cdn.molouadx.com/web/scene-bg.png) no-repeat;
	  background-size: cover;
	  width:100%;
	  padding-top: 60px;
	  .scene-content {
		  width: 66%;
		  margin-left: 17%;
		  padding-top: 50px;
		  .title-box {
			width: 70%;
			margin-left: 15%;
			aspect-ratio: 1085 / 104;
			background: url(https://cdn.molouadx.com/web/title-bg2.png) no-repeat;
			background-size: cover;
			display: flex;
			justify-content: center;
			align-items: center;
			.title-wrap {
				height: 50px;
				font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
				font-weight: 400;
				font-size: 32px;
				color: #FF5722;
				line-height: 45px;
				text-align: center;
				font-style: normal;
				text-transform: none;
			}
		}
		.scene-description {
			margin-top: 50px;
			font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
			font-weight: 400;
			font-size: 16px;
			color: #000000;
			line-height: 32px;
			text-align: center;
			font-style: normal;
			text-transform: none;
		}
		.scene-main {
			width: 100%;
			display: flex;
			height: 428px;
			margin-top: 80px;
			.main-left {
				width: calc(100% * 0.66 * (300 / 950));
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				.left-btn {
					cursor: pointer;
					width: 100%;
					height: 60px;
					border-radius: 600px 600px 600px 600px;
					border: 3px solid #FF5722;
					font-family: Source Han Sans, Source Han Sans;
					font-weight: 350;
					font-size: 18px;
					color: #FF5722;
					line-height: 60px;
					text-align: center;
					font-style: normal;
					text-transform: none;
				}
				.left-btn-active {
					background: #FF5722;
					border-radius: 600px 600px 600px 600px;
					border: 1px solid rgba(255,255,255,0.8);
					color: #FFFFFF;
				}
			}
			.main-right {
				width: 100%;
				padding-left: 80px;
				.right-content {
					display: flex;
					.content-left {
						flex:1.5;
						padding-right: 35px;
						.content-left-title {
							font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
							font-weight: 400;
							font-size: 30px;
							color: #030C22;
							line-height: 41px;
							text-align: left;
							font-style: normal;
							text-transform: none;
						}
						.content-left-description {
							font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
							font-weight: 400;
							font-size: 16px;
							color: #030C22;
							line-height: 27px;
							text-align: left;
							font-style: normal;
							text-transform: none;
						}
						.sub-title {
							font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
							font-weight: 400;
							font-size: 18px;
							color: #030C22;
							line-height: 30px;
							text-align: left;
							font-style: normal;
							text-transform: none;
						}
					}
					.content-right {
						flex:1;
						.right-icon {
							width: 181px;
							height: 400px;
						}
					}
				}
			}
		}
	}
  }
  .case-section {
	  width: 100%;
	  height: 800px;
	  background-color: #10162E;
		.case-content {
		  width: 66%;
		  margin-left: 17%;
		  padding-top: 100px;
		  .title-box {
			width: 70%;
			margin-left: 15%;
			aspect-ratio: 1012 / 112;
			background: url(https://cdn.molouadx.com/web/title-bg.png) no-repeat;
			background-size: cover;
			display: flex;
			justify-content: center;
			align-items: center;
			.title-wrap {
				height: 50px;
				font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
				font-weight: 400;
				font-size: 32px;
				color: #FFFFFF;
				line-height: 45px;
				text-align: center;
				font-style: normal;
				text-transform: none;
			}
		  }
		  .description {
			  font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
			  font-weight: 500;
			  font-size: 16px;
			  color: #9CA3AF;
			  line-height: 32px;
			  text-align: center;
			  font-style: normal;
			  text-transform: none;
			  margin-top: 30px;
			  margin-bottom: 80px;
		  }
		  .case-main {
			  display: flex;
			  width: 100%;
			  justify-content: space-between; 
			  .main-item {
				  width: 220px;
				  height: 170px;
				  background: rgba(255,87,34,0.1);
				  border-radius: 16px 16px 16px 16px;
				  border: 2px solid #FF5722;
				  // padding: 32px;
				  .item-no {
					  padding-left: 20px;
					  margin-top: 10px;
					  font-family: Roboto, Roboto;
					  font-weight: 700;
					  font-size: 28px;
					  color: #FF5722;
					  line-height: 30px;
					  text-align: left;
					  font-style: normal;
					  text-transform: none;
				  }
				  .item-title {
					  padding-left: 20px;
					  font-family: Roboto, Roboto;
					  font-weight: 700;
					  font-size: 16px;
					  color: #E2E8F0;
					  line-height: 28px;
					  text-align: left;
					  font-style: normal;
					  text-transform: none;
					  margin-top: 10px;
				  }
				  .item-description {
					  padding-left: 20px;
					   padding-right: 20px;
					  font-family: Rhodium Libre, Rhodium Libre;
					  font-weight: 400;
					  font-size: 14px;
					  color: #9CA3AF;
					  line-height: 24px;
					  text-align: left;
					  font-style: normal;
					  text-transform: none;
					   margin-top: 5px;
				  }
			  }
			  margin-bottom: 30px;
		  }
		}
	}
	.footer {
		width: 100%;
		height: 280px;
		aspect-ratio: 1920 / 300;
		background: url(https://cdn.molouadx.com/web/footer-bg.png) no-repeat;
		background-size: cover;
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		.footer-content {
		  width: 100%;
		  // margin-left: 17%;
		  height: 166px;
		  display: flex;
		  justify-content: center;
		  align-items: center;
		  flex-direction: column;
		  .title {
			  font-family: Alimama FangYuanTi VF, Alimama FangYuanTi VF;
			  font-weight: 600;
			  font-size: 38px;
			  color: #FFFFFF;
			  line-height: 32px;
			  letter-spacing: 19px;
			  text-align: center;
			  font-style: normal;
			  text-transform: none;
		  }
		  .btn {
			  cursor: pointer;
			  border-radius: 0px 0px 0px 0px;
			  border: 3px solid #FFFFFF;
			  width: 220px;
			  height: 68px;
			  font-family: Alimama FangYuanTi VF-Regular, Alimama FangYuanTi VF-Regular;
			  font-weight: 400;
			  font-size: 28px;
			  color: #FFFFFF;
			  line-height: 68px;
			  letter-spacing: 13px;
			  text-align: center;
			  font-style: normal;
			  text-transform: none;
			  margin-top: 32px;
		  }
		}
		.icon {
			position: absolute;
			right: 100px;
			top: 38.5px;
			width: 149px;
			height: 203px;
		}
		.copyright {
			position: absolute;
			bottom: 10px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			color: #fff;
			font-size: 14px;
			text-align: center;
			font-style: normal;
			line-height: 20px;
			text-align: center;
		}
	}
}

</style>



// WEBPACK FOOTER //
// src/pages/Home.vue